import React from 'react';
import '../styles/theme.css';
import '../styles/NewCrawl.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import NewCrawlOpener from '../components/NewCrawlOpener';
import NewCrawlTargetForm from '../components/NewCrawlTargetForm';
/* IMPORTS */

function NewCrawlPage() {
  return (
    <div className="ne-root">
      <div className="ne-layout-1">
        <div id="newcrawlnavbar" className="ne-slot-newcrawlnavbar">
          <Navbar activePage={"New Crawl"} />
        </div>
        <div className="ne-layout-2">
          <div id="newcrawlopener" className="ne-slot-newcrawlopener">
            <NewCrawlOpener />
          </div>
          <div id="newcrawltargetform" className="ne-slot-newcrawltargetform">
            <NewCrawlTargetForm />
          </div>
        </div>
        <div id="newcrawlfooter" className="ne-slot-newcrawlfooter">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default NewCrawlPage;
